<markdown
  [data]="processedMarkdown()"
  katex
  [katexOptions]="katexOptions"
  ngPreserveWhitespaces
  [disableSanitizer]="true"
/>
